// extracted by mini-css-extract-plugin
export default {"overlay":"Kh1Qvch1","modal":"W8L7ifs9","close":"DrrI_t5i","videoWrapper":"ohhMRRh9","video":"i4bSNPcU","progressTop":"ulXtYMx2","progressFill":"UwuOTnqO"};